/*********************************************************************** 
Documentations = https://github.com/azouaoui-med/pro-sidebar-template
************************************************************************/
import $ from 'jquery';
import React, {useEffect, useState, useRef} from 'react';
import {withTranslation} from 'react-i18next';
// import MenuItemIcon from '../MenuItemIcon';
import {
    FaCog,
    FaSignOutAlt,
    FaUser,
    FaBiking,
    FaTrophy,
    FaCity,
    FaHome,
    FaMoneyBillAlt,
    FaMedal,
    FaQuestion,
    FaInfo,
    FaHandPointRight,
    FaTasks,
    FaPlay,
    FaCalendar,
    FaMoneyBillWaveAlt,
    FaYoutube,
} from 'react-icons/fa';
import {GiPayMoney, GiRibbonMedal, GiChatBubble, GiShop, GiShoppingBag, GiPriceTag} from 'react-icons/gi';
import {Menu, MenuItem, ProSidebar, SidebarContent, SidebarFooter, SidebarHeader, SubMenu} from 'react-pro-sidebar';
import {Link} from 'react-router-dom';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import ActionButton from '../ActionButton';
import ActionLink from '../ActionLink';
import {InputText} from 'primereact/inputtext';
import SidebarSearch from '../SidebarSearch';
import StringUtils from '../../utils/StringUtils';

const Sidebar = ({
    t,
    collapsed,
    toggled,
    loggedUser,
    handleToggleSidebar,
    handleLogoutUser,
    authService,
    userService,
    submenu,
    activeUrl,
    generatedDocumentAvailable,
}) => {
    // const role = authService.getProfile().role;
    const [showMenu, changeShowMenu] = useState(false);
    const [key, setKey] = useState(0); // Używamy klucza do wymuszenia ponownego renderowania

    const [collapsedSelected, changeCollapsed] = useState(collapsed);
    const [showFuntionsMenu, changeShowFunctionsMenu] = useState(false);
    const [showAgreements, changeShowAgreements] = useState(false);
    const [showLanguages, changeShowLanguages] = useState(false);
    const [stateActiveUrl, changeStateActiveUrl] = useState();
    const sidebarRef = useRef(undefined);

    const handleCollapseChange = React.useCallback(() => {
        changeCollapsed(!collapsedSelected);
        if (collapsedSelected) {
            $('.pro-item-content').css('display', 'flex');
            $('.pro-sidebar-background').css('width', '240px');
            $('.pro-sidebar').css('min-width', '240px');
            $('.pro-sidebar').css('width', '240px');
            $('.toggler-btn').css('justify-content', 'right');
            $('.toggler-btn').css('margin-top', '5px');
            $('.logo').css('display', 'flex');
            $('.popper-inner').css('display', 'none');
        } else {
            $('.pro-item-content').css('display', 'none');
            $('.pro-sidebar-background').css('width', '100px');
            $('.pro-sidebar').css('min-width', '100px');
            $('.pro-sidebar').css('width', '100px');
            $('.toggler-btn').css('justify-content', 'center');
            $('.toggler-btn').css('margin-top', '20px');
            $('.logo').css('display', 'none');
            $('.popper-inner').css('display', 'flex');
        }
    }, [collapsedSelected, changeCollapsed]); // Dodaj zależności

    const handleResize = React.useCallback(() => {
        const currentWidth = window.innerWidth;
        if (currentWidth < 1024 && collapsedSelected) {
            handleCollapseChange();
        }
    }, [collapsedSelected, handleCollapseChange]);

    useEffect(() => {
        if (activeUrl !== stateActiveUrl) {
            $('.pro-inner-item').each(function (index) {
                $(this).removeClass('active');
            });
            $(document.getElementsByClassName(`pro-menu-item ${activeUrl}`))
                .children('div')
                .addClass('active')
                .siblings()
                .removeClass('active');
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [activeUrl, stateActiveUrl, handleResize]);

    function handleActiveMenu(url) {
        $('.pro-inner-item').each(function (index) {
            $(this).removeClass('active');
        });
        $(document.getElementsByClassName(`pro-menu-item ${url}`))
            .children('div')
            .addClass('active')
            .siblings()
            .removeClass('active');
    }
    const makeAllItemsVisible = () => {
        const items = Array.from(document.getElementsByClassName('pro-menu-item'));
        items.forEach((item) => {
            item.style.display = '';
        });
    };

    function renderOverlay() {
        return (
            <div
                className='show-menu-overlay'
                onClick={(e) => {
                    e.preventDefault();
                    if (showMenu || showFuntionsMenu) {
                        changeShowMenu(false);
                        changeShowFunctionsMenu(false);
                        changeShowLanguages(false);
                        changeShowAgreements(false);
                    }
                }}
            />
        );
    }

    function renderHorizontalSidebar() {
        // return (!authService.loggedIn() && !submenu) || publicMode ? null : (
        return !submenu ? null : (
            <div>
                <div className=' sidebar-horizontal-content'>
                    <ActionButton
                        label={t('sidebar.sidebarMenuButton')}
                        variant={showMenu ? 'sidebar-button menu-close' : 'sidebar-button menu'}
                        handleClick={(e) => {
                            e.preventDefault();
                            changeShowMenu(!showMenu);
                            changeShowFunctionsMenu(false);
                            changeShowLanguages(false);
                            changeShowAgreements(false);
                        }}
                        iconSvg={showMenu ? 'ico-sidebar-close' : 'ico_sidebar_menu'}
                        iconSide='left'
                        iconSize={showMenu ? 'menu-close' : 'menu'}
                    />
                </div>
                <div id='sidebar' className={`sidebar ${showMenu ? 'show-menu' : ''}`}>
                    {renderVerticalSidebar()}
                </div>
                <div className={`sidebar functions-menu ${showFuntionsMenu ? 'show-menu' : ''}`}>{renderFunctionsSidebar()}</div>
            </div>
        );
    }
   
    function renderVerticalSidebar() {
        return (
            <React.Fragment>
                {renderOverlay()}
                <ProSidebar
                    ref={sidebarRef}
                    id='sidebar-vertical'
                    collapsed={collapsedSelected}
                    toggled={toggled}
                    onToggle={handleToggleSidebar}
                    className='pro-sidebar-layout'
                >
                    <SidebarHeader id='sidebarHeader'>
                        <div id='toggler-btn-row' className='row no-gutters'>
                            <div className='col-12 cursor-pointer'>
                                <div className='toggler-btn'>
                                    <i
                                        className='mdi mdi-menu'
                                        style={{color: 'white', fontSize: '30px'}}
                                        onClick={() => {
                                            if (window.innerWidth <= 1023) {
                                                const sidebar = document.getElementById('sidebar');
                                                sidebar.classList.remove('show-menu');
                                            } else {
                                                handleCollapseChange();
                                            }
                                            makeAllItemsVisible();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div id='logo' className='logo '>
                            <img
                                className='card-icon logo'
                                style={{maxWidth: '100px'}}
                                alt=''
                                src={AppPrefixUtils.locationHrefUrl(`/images/logo.svg`)}
                            />
                        </div>
                        <SidebarSearch rendered={!collapsedSelected}/>
                    </SidebarHeader>

                    <SidebarContent>
                        <Menu>
                            {authService.isUserInAnyRole('ROLE_SUPER_ADMINISTRATOR', 'ROLE_ADMINISTRATOR') ? (
                                <Menu>
                                    <MenuItem
                                        className='dashboard'
                                        icon={<FaHome />}
                                        onClick={() => {
                                            const link = document.getElementById('dashboard-link');
                                            if (collapsedSelected) {
                                                link.click();
                                            }
                                        }}
                                    >
                                        <Link
                                            id='dashboard-link'
                                            to='/dashboard'
                                            onClick={() => {
                                                handleActiveMenu('dashboard');
                                            }}
                                        />
                                        Dashboard
                                    </MenuItem>
                                </Menu>
                            ) : (
                                <span />
                            )}
                            {authService.isUserInAnyRole('ROLE_SUPER_ADMINISTRATOR', 'ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR') ? (
                                <Menu>
                                    <MenuItem
                                        className='ranking'
                                        icon={<FaMedal />}
                                        onClick={() => {
                                            const link = document.getElementById('ranking-link');
                                            if (collapsedSelected) {
                                                link.click();
                                            }
                                        }}
                                    >
                                        <Link
                                            id='ranking-link'
                                            to='/ranking'
                                            onClick={() => {
                                                handleActiveMenu('ranking');
                                            }}
                                        />
                                        {t('sidebar.ranking')}
                                    </MenuItem>
                                </Menu>
                            ) : (
                                <span />
                            )}
                          
                            {authService.isUserInAnyRole('ROLE_SUPER_ADMINISTRATOR', 'ROLE_ADMINISTRATOR') ? (
                                <Menu>
                                    <MenuItem
                                        className='company'
                                        icon={<FaCity />}
                                        onClick={() => {
                                            const link = document.getElementById('company-link');
                                            if (collapsedSelected) {
                                                link.click();
                                            }
                                        }}
                                    >
                                        <Link
                                            id='company-link'
                                            to='/company/details'
                                            onClick={() => {
                                                handleActiveMenu('company');
                                            }}
                                        />
                                        {t('sidebar.company')}
                                    </MenuItem>
                                </Menu>
                            ) : (
                                <span />
                            )}
                            {authService.isUserInAnyRole('ROLE_VIEW_ROUTES', 'ROLE_ADMINISTRATOR') ? (
                                <Menu>
                                    <MenuItem
                                        className='user-transport-list'
                                        icon={<FaBiking />}
                                        onClick={() => {
                                            const link = document.getElementById('user-transport-list-link');
                                            if (collapsedSelected) {
                                                link.click();
                                            }
                                        }}
                                    >
                                        <Link
                                            id='user-transport-list-link'
                                            to='/user-transport-list'
                                            onClick={() => {
                                                handleActiveMenu('user-transport-list');
                                            }}
                                        />
                                        {t('sidebar.activities')}
                                    </MenuItem>
                                </Menu>
                            ) : (
                                <span />
                            )}
                            {authService.isUserInAnyRole('ROLE_VIEW_ROUTES', 'ROLE_ADMINISTRATOR') ? (
                                <Menu>
                                    <MenuItem
                                        className='user-summary-list'
                                        icon={<FaMoneyBillWaveAlt />}
                                        onClick={() => {
                                            const link = document.getElementById('user-summary-list-link');
                                            if (collapsedSelected) {
                                                link.click();
                                            }
                                        }}
                                    >
                                        {t('sidebar.summary')}
                                        <Link
                                            id='user-summary-list-link'
                                            to='/user-summary-list'
                                            onClick={() => {
                                                handleActiveMenu('user-summary-list');
                                            }}
                                        />
                                    </MenuItem>
                                </Menu>
                            ) : (
                                <span />
                            )}
                            {authService.isUserInAnyRole('ROLE_ADMINISTRATOR') ? (
                                <Menu>
                                    <MenuItem
                                        className='/user-payroll-list'
                                        icon={<FaMoneyBillAlt />}
                                        onClick={() => {
                                            const link = document.getElementById('/user-payroll-list');
                                            if (collapsedSelected) {
                                                link.click();
                                            }
                                        }}
                                    >
                                        {t('sidebar.payroll')}
                                        <Link
                                            id='/user-payroll-list'
                                            to='/user-payroll-list'
                                            onClick={() => {
                                                handleActiveMenu('/user-payroll-list');
                                            }}
                                        />
                                    </MenuItem>
                                </Menu>
                            ) : (
                                <span />
                            )}

                            
                           
                            
                            {authService.isUserInAnyRole('ROLE_CONTENT_CREATOR', 'ROLE_ADMINISTRATOR') ? (
                                <Menu>
                                    <MenuItem
                                        className='/event-list'
                                        icon={<FaCalendar />}
                                        onClick={() => {
                                            const link = document.getElementById('/event-list');
                                            if (collapsedSelected) {
                                                link.click();
                                            }
                                        }}
                                    >
                                        {t('sidebar.event')}
                                        <img
                                            src={AppPrefixUtils.locationHrefUrl(`/images/new.png`)}
                                            alt='new'
                                            style={{height: '25px', marginLeft: '2px'}} 
                                        />
                                        <Link
                                            id='/event-list'
                                            to='/event-list'
                                            onClick={() => {
                                                handleActiveMenu('/event-list');
                                            }}
                                        />
                                    </MenuItem>
                                </Menu>
                            ) : (
                                <span />
                            )} 

                            {authService.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR') ? (
                                <SubMenu title={t('sidebar.comunication')} icon={<GiChatBubble />}>
                                    <Menu iconShape='circle' popperArrow='false'>
                                        <MenuItem className='news-list'>
                                            {t('news.name')}{' '}
                                            <Link
                                                to='/news-list'
                                                onClick={() => {
                                                    handleActiveMenu('news-list');
                                                }}
                                            />{' '}
                                        </MenuItem>
                                    </Menu>
                                    <Menu iconShape='circle' popperArrow='false'>
                                        <MenuItem className='pushMsg-list'>
                                            {t('pushMsg.name')}{' '}
                                            <Link
                                                to='/pushMsg-list'
                                                onClick={() => {
                                                    handleActiveMenu('pushMsg-list');
                                                }}
                                            />{' '}
                                        </MenuItem>
                                    </Menu>
                                </SubMenu>
                            ) : (
                                <span />
                            )}
                            {authService.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR') ? (
                                <SubMenu title={t('sidebar.acheive')} icon={<GiRibbonMedal />}>
                                    <Menu iconShape='circle' popperArrow='false'>
                                        <MenuItem className='challenge-list'>
                                            {t('challenge.listTitle')}
                                            <Link
                                                to='/challenge-list'
                                                onClick={() => {
                                                    handleActiveMenu('challenge-list');
                                                }}
                                            />{' '}
                                        </MenuItem>
                                    </Menu>
                                    {/* <Menu iconShape='circle' popperArrow='false'>
                                        <MenuItem className='achievements-list'>
                                            {t('achievement.listTitle')}
                                            <Link
                                                to='/achievements-list'
                                                onClick={() => {
                                                    handleActiveMenu('achievements-list');
                                                }}
                                            />{' '}
                                        </MenuItem>
                                    </Menu> */}
                                {authService.isUserInAnyRole('ROLE_CONTENT_CREATOR', 'ROLE_ADMINISTRATOR') ? (
                                <Menu>
                                    <MenuItem
                                        className='/quiz-list'
                                        icon={<FaQuestion />}
                                        onClick={() => {
                                            const link = document.getElementById('/quiz-list');
                                            if (collapsedSelected) {
                                                link.click();
                                            }
                                        }}
                                    >
                                        {t('sidebar.quiz')}
                                        <Link
                                            id='/quiz-list'
                                            to='/quiz-list'
                                            onClick={() => {
                                                handleActiveMenu('/quiz-list');
                                            }}
                                        />
                                    </MenuItem>
                                </Menu>
                            ) : (
                                <span />
                            )}
                             {authService.isUserInAnyRole('ROLE_CONTENT_CREATOR', 'ROLE_ADMINISTRATOR') ? (
                                <Menu>
                                    <MenuItem
                                        className='/action-list'
                                        icon={<FaPlay />}
                                        onClick={() => {
                                            const link = document.getElementById('/action-list');
                                            if (collapsedSelected) {
                                                link.click();
                                            }
                                        }}
                                    >
                                        {t('sidebar.action')}
                                        <img
                                            src={AppPrefixUtils.locationHrefUrl(`/images/new.png`)}
                                            alt='new'
                                            style={{height: '25px', marginLeft: '2px'}} 
                                        />
                                        <Link
                                            id='/action-list'
                                            to='/action-list'
                                            onClick={() => {
                                                handleActiveMenu('/action-list');
                                            }}
                                        />
                                    </MenuItem>
                                </Menu>
                            ) : (
                                <span />
                            )}
                                </SubMenu>
                            ) : (
                                <span />
                            )}

                                {authService.isUserInAnyRole('ROLE_ADMINISTRATOR', 'ROLE_CONTENT_CREATOR') ? (
                                    <SubMenu title={t('sidebar.prize')} icon={<GiPriceTag />}>

                                        <Menu iconShape='circle' popperArrow='true'>
                                            <MenuItem className='voucher-list'>
                                                <div
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        changeShowMenu(false);
                                                    }}
                                                >
                                                    {t('voucher.sidebar')}
                                                    <Link to='/voucher-list' 
                                                    onClick={() => {
                                                        handleActiveMenu('voucher-list');
                                                    }}/>{' '}
                                                </div>
                                            </MenuItem>
                                        </Menu>
                                       
                                        <Menu iconShape='circle' popperArrow='true'>
                                            <MenuItem className='voucher-purchased-list'>
                                                <div
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        changeShowMenu(false);
                                                    }}
                                                >
                                                    {t('voucher.purchased')}
                                                    <Link to='/voucher-purchased-list' 
                                                    onClick={() => {
                                                        handleActiveMenu('voucher-purchased-list');
                                                    }}/>{' '}
                                                </div>
                                            </MenuItem>
                                        </Menu>
                                        </SubMenu>
                                    ) : null}
                                   

                            {authService.isUserInAnyRole('ROLE_ADMINISTRATOR') ? (
                                <SubMenu title={t('sidebar.administration')} icon={<FaCog />}>
                                    <Menu iconShape='circle' popperArrow='false'>
                                        <MenuItem className='users-list'>
                                            {t('user.listName')}
                                            <Link
                                                to='/users-list'
                                                onClick={() => {
                                                    handleActiveMenu('users-list');
                                                }}
                                            />{' '}
                                        </MenuItem>
                                    </Menu>
                                    <Menu iconShape='circle' popperArrow='false'>
                                        <MenuItem className='mobile-user-list'>
                                            {t('mobileUser.listTitle')}
                                            <Link
                                                to='/mobile-user-list'
                                                onClick={() => {
                                                    handleActiveMenu('mobile-user-list');
                                                }}
                                            />
                                        </MenuItem>
                                    </Menu>
                                    <Menu iconShape='circle' popperArrow='false'>
                                        <MenuItem className='company-transport-list'>
                                            {t('transport.listName')}
                                            <Link
                                                to='/company-transport-list'
                                                onClick={() => {
                                                    handleActiveMenu('company-transport-list');
                                                }}
                                            />{' '}
                                        </MenuItem>
                                    </Menu>
                                    <Menu iconShape='circle' popperArrow='true'>
                                            <MenuItem className='voucher-category-list'>
                                                <div
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        changeShowMenu(false);
                                                    }}
                                                >
                                                    {t('category.sidebar')}
                                                    <Link to='/voucher-category-list'
                                                     onClick={() => {
                                                        handleActiveMenu('voucher-category-list');
                                                    }} />{' '}
                                                </div>
                                            </MenuItem>
                                        </Menu>

                                    {authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR') ? (
                                        <Menu iconShape='circle' popperArrow='false'>
                                            <MenuItem className='email-template-list'>
                                                {t('sidebar.email')}
                                                <Link
                                                    to='/email-template-list'
                                                    onClick={() => {
                                                        handleActiveMenu('email-template-list');
                                                    }}
                                                />{' '}
                                            </MenuItem>
                                            </Menu>                                        
                                    ) : (
                                        <span />
                                    )}
                                    {authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR') ? (
                                        <Menu iconShape='circle' popperArrow='false'>
                                            <MenuItem className='issue-list'>
                                                {t('sidebar.issues')}
                                                <Link
                                                    to='/issue-list'
                                                    onClick={() => {
                                                        handleActiveMenu('issue-list');
                                                    }}
                                                />{' '}
                                            </MenuItem>
                                        </Menu>
                                    ) : (
                                        <span />
                                    )}
                                     {authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR') ? (
                                    <Menu iconShape='circle' popperArrow='false'>
                                            <MenuItem className='transport-list'>
                                                {t('transport-def.listName')}
                                                <Link
                                                    to='/transport-list'
                                                    onClick={() => {
                                                        handleActiveMenu('transport-list');
                                                    }}
                                                />{' '}
                                            </MenuItem>
                                        </Menu>
                                     ) : (
                                        <span />
                                     )}

                                    <Menu iconShape='circle' popperArrow='false'>
                                        <MenuItem className='user-ranks-list'>
                                            {t('sidebar.ranks')}{' '}
                                            <Link
                                                to='/user-ranks-list'
                                                onClick={() => {
                                                    handleActiveMenu('user-ranks-list');
                                                }}
                                            />{' '}
                                        </MenuItem>
                                    </Menu>
                                    <Menu iconShape='circle' popperArrow='false'>
                                        <MenuItem className='logentry-list'>
                                            {t('sidebar.logentry')}{' '}
                                            <Link
                                                to='/logentry-list'
                                                onClick={() => {
                                                    handleActiveMenu('logentry-list');
                                                }}
                                            />{' '}
                                        </MenuItem>
                                    </Menu>
                                </SubMenu>
                            ) : (
                                <span />
                            )}
                        </Menu>
                        <Menu iconShape='circle' popperArrow='false'>
                            <MenuItem className='help' icon={<FaInfo />}>
                                {t('sidebar.help')}
                                <a href={process.env.REACT_APP_MANUAL_URL} target='_blank' rel='noopener noreferrer' />
                            </MenuItem>
                            <MenuItem className='youtube-tutorials' icon={<FaYoutube />}>
                                {t('sidebar.youtubeTutorials')}
                                <a
                                    href='https://www.youtube.com/playlist?list=PLKnz_CYps-sCDYirQXTFs8xmPsWrq7F1Z'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                />
                            </MenuItem>
                        </Menu>
                    </SidebarContent>
                    <SidebarFooter>
                        <span className='sidebar-version' style={{marginLeft: '10px', fontSize: '11px'}}>
                            ver: {process.env.REACT_APP_VERSION}, build: {process.env.REACT_APP_BUILD_NUMBER}
                        </span>
                    </SidebarFooter>
                </ProSidebar>
            </React.Fragment>
        );
    }

    function renderFunctionsSidebar() {
        // TODO:
        // return !authService.loggedIn() || publicMode ? null : (
        return (
            <React.Fragment>
                {renderOverlay()}
                <ProSidebar
                    collapsed={collapsed}
                    toggled={toggled}
                    onToggle={handleToggleSidebar}
                    className='pro-sidebar-layout functions-menu'
                >
                    <SidebarContent>
                        <Menu>
                            {authService.getProfile().sapRoleIdsList?.length > 1 ? (
                                <MenuItem key='agreement' className='sidebar-submenu'>
                                    <div
                                        onClick={(e) => {
                                            e.preventDefault();
                                            changeShowAgreements(!showAgreements);
                                            changeShowLanguages(false);
                                        }}
                                    >
                                        {t('header.agreement')}
                                    </div>
                                </MenuItem>
                            ) : null}

                            <MenuItem icon={<FaUser />} className='drivers-list'>
                                <span>{t('profile.title')}</span>
                                <ActionLink
                                    href={AppPrefixUtils.locationHrefUrl('/manage-account/details/' + authService.getProfile().userId)}
                                    className='header-link'
                                    rel='noopener noreferrer'
                                />
                            </MenuItem>

                            <MenuItem icon={<FaSignOutAlt />} className='drivers-list'>
                                <div
                                    onClick={(e) => {
                                        e.preventDefault();
                                        changeShowFunctionsMenu(!showFuntionsMenu);
                                        changeShowLanguages(false);
                                        changeShowAgreements(false);
                                        handleLogoutUser();
                                    }}
                                    className='header-link'
                                    rel='noopener noreferrer'
                                >
                                    <span>{t('header.logout')}</span>
                                </div>
                            </MenuItem>
                        </Menu>
                    </SidebarContent>
                </ProSidebar>
            </React.Fragment>
        );
    }

    function render() {
        return submenu ? renderHorizontalSidebar() : renderVerticalSidebar();
    }

    return render();
};

export default withTranslation()(Sidebar);
